import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
// Store
import { useStore } from "../../../store";
// Components
import Button from "../../../components/Button/Button";
import OrderDetails from "../../Checkout/OrderDetails/OrderDetails";
// Constants
import { SCHEDULE_TYPES } from "../../Schedule/ScheduleContent/ScheduleContent";
// Styles
import styles from "./PaymentSuccessContent.module.scss";
// Images
import calendarIcon from "../../../assets/images/calendar_icon.png";
import clockIcon from "../../../assets/images/time_icon.png";
//Amplitude
import * as amplitude from "@amplitude/analytics-browser";

const PaymentSuccessContent = () => {
  const navigate = useNavigate();
  const {
    chosenPackage,
    contactInfo,
    scheduleData,
    fieldRoutesCustomer,
    cardDetails,
    resetState,
  } = useStore();

  const chosenPackageMemo = useMemo(() => {
    return chosenPackage;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const contactInfoMemo = useMemo(() => {
    return contactInfo;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const scheduleDataMemo = useMemo(() => {
    return scheduleData;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fieldRoutesCustomerMemo = useMemo(() => {
    return fieldRoutesCustomer;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const cardDetailsMemo = useMemo(() => {
    return cardDetails;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    resetState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      !contactInfoMemo ||
      !scheduleDataMemo ||
      !fieldRoutesCustomerMemo ||
      !cardDetailsMemo
    ) {
      navigate("/contact");
    }
  }, [
    contactInfoMemo,
    scheduleDataMemo,
    fieldRoutesCustomerMemo,
    cardDetailsMemo,
    navigate,
  ]);

  const hideScheduleSection =
    scheduleDataMemo?.scheduleType === SCHEDULE_TYPES.FIRST_AVAILABLE;

  const calculateTimeLabel = () => {
    if (!scheduleDataMemo?.chosenTime) {
      return "";
    }

    if (scheduleDataMemo?.chosenTime === "8-11AM") {
      return "Morning 8-11AM";
    }

    if (scheduleDataMemo?.chosenTime === "8-12PM") {
      return "Morning 8-12PM";
    }

    if (scheduleDataMemo?.chosenTime === "11-2:30PM") {
      return "Mid-day 11-2:30PM";
    }

    if (scheduleDataMemo?.chosenTime === "2:30-5:30PM") {
      return "Afternoon 2:30-5:30PM";
    }
  };

  const handleTakeMeThereClick = () => {
    const pageViewedEvent = {
      event_type: "Page Viewed",
      display_name: "Page Viewed",
      event_properties: {
        page_name: "Wix - Service details (from eComm)",
      },
    };

    const buttonClickedEvent = {
      event_type: "Button Clicked",
      display_name: "Button Clicked",
      event_properties: {
        page_name: "eComm - Confirmation Page",
        button_name: "More details",
      },
    };

    amplitude.track(buttonClickedEvent);
    amplitude.track(pageViewedEvent);

    window.open("https://www.magnapest.com/residential", "_blank");
  };

  useEffect(() => {
    const pageViewedEvent = {
      event_type: "Page Viewed",

      display_name: "Page Viewed",

      event_properties: {
        page_name: "eComm - Confirmation Page",
      },
    };

    amplitude.track(pageViewedEvent);
  }, []);

  if (
    !chosenPackageMemo ||
    !contactInfoMemo ||
    !cardDetailsMemo ||
    !fieldRoutesCustomerMemo
  ) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.titleSection}>
          <h1 className={styles.title}>
            Thanks {contactInfoMemo.firstName} for choosing Magna Pest
            Solutions!
          </h1>
          <p className={styles.description}>
            A confirmation email has been sent to your email address.
          </p>
        </div>

        <div className={styles.initialServiceSection}>
          <h3 className={styles.sectionTitle}>Initial Service</h3>

          <div className={styles.sectionTitleDivider} />

          <p className={styles.sectionDescription}>
            Within 1 business day you’ll receive another email confirming the
            appointment time.
          </p>

          <div>
            <p className={styles.serviceAddressTitle}>Service Address</p>
            <p className={styles.address}>{contactInfoMemo.address}</p>
          </div>

          {!hideScheduleSection && (
            <div className={styles.scheduleContent}>
              <div>
                <p className={styles.serviceAddressTitle}>
                  <img src={calendarIcon} alt="day" /> Preferred Day
                </p>
                <p className={styles.scheduleValue}>
                  {scheduleDataMemo.chosenDay}
                </p>
              </div>

              <div>
                <p className={styles.serviceAddressTitle}>
                  <img src={clockIcon} alt="time" /> Preferred Time
                </p>
                <p className={styles.scheduleValue}>{calculateTimeLabel()}</p>
              </div>
            </div>
          )}
        </div>

        <div className={styles.paymentMethodSection}>
          <div className={styles.paymentContent}>
            <h3 className={styles.sectionTitle}>Payment Method</h3>

            <div className={styles.sectionTitleDivider} />

            <div className={styles.cardData}>
              <div className={styles.cardItem}>
                <span className={styles.cardItemTitle}>Card</span>
                <span className={styles.cardItemValue}>
                  {cardDetailsMemo.brand}
                </span>
              </div>

              <div className={styles.cardItem}>
                <span className={styles.cardItemTitle}>Card Number</span>
                <span className={styles.cardItemValue}>
                  **** **** **** {cardDetailsMemo.last4}
                </span>
              </div>
            </div>
          </div>

          <div className={styles.linkContent}>
            <span className={styles.linkText}>
              Want more details about our services?
            </span>
            <Button
              className={styles.linkButton}
              htmlType="button"
              type="outline"
              onClick={handleTakeMeThereClick}
            >
              Take me there
            </Button>
          </div>
        </div>

        <div className={styles.orderSection}>
          <OrderDetails
            isConfirmationPage
            chosenPackage={chosenPackageMemo}
            fieldRoutesCustomer={fieldRoutesCustomerMemo}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessContent;
